<template>
  <a-config-provider :locale="language === 'English' ? enUS : zhCN">
    <div
      style="
        padding: 16px 16px;
        height: calc(100vh - 100px);
        background-color: #080718ff;
        overflow-y: scroll;
        padding-bottom: 30px;
        background-color: #080718ff;
        color: #fff;
      "
    >
      <div class="box p-5">
        <div class="w-full">
          <a-form
            :model="searchModel"
            name="horizontal_login"
            layout="inline"
            autocomplete="off"
          >
            <a-form-item :label="getLanguage('监测类型')" name="type">
              <a-select
                v-model:value="searchModel.type"
                style="width: 220px"
                :placeholder="getLanguage('请选择')"
              >
                <a-select-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :label="getLanguage('报警状态')" name="type">
              <a-select
                v-model:value="searchModel.status"
                style="width: 220px"
                :placeholder="getLanguage('请选择')"
              >
                <a-select-option
                  v-for="(item, index) in statusList"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :label="getLanguage('报警时间')" name="type">
              <a-range-picker
                v-model:value="searchModel.date"
                :allowClear="false"
              />
            </a-form-item>

            <a-form-item>
              <div class="flex items-center">
                <div
                  @click="reset"
                  class="btn px-5 py-1 fff cursor-pointer ml-4"
                >
                  {{ getLanguage("重置") }}
                </div>
                <div
                  @click="search"
                  class="btn px-5 py-1 fff cursor-pointer ml-4"
                  style="background-color: #171325ff"
                >
                  {{ getLanguage("查询") }}
                </div>
                <div
                  @click="dealWith"
                  class="btn px-5 py-1 fff cursor-pointer ml-4"
                  style="background-color: #171325ff"
                >
                  {{ getLanguage("处理报警") }}
                </div>
              </div>
            </a-form-item>
          </a-form>
        </div>

        <div class="box mt-4" style="width: 100%">
          <a-table
            style="width: 100%"
            size="small"
            :row-class-name="getRowClassName"
            :columns="columns"
            :data-source="dataList"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
              getCheckboxProps: getCheckboxProps,
            }"
            :pagination="pagination"
            @change="handleTableChange"
            rowKey="id"
          >
            <template #bodyCell="{ column, text, record }">
              <template v-if="column.dataIndex === 'status'">
                <div v-if="!text">{{ getLanguage("未处理") }}</div>
                <a @click="view(record)" v-if="text">{{
                  getLanguage("已处理")
                }}</a>
              </template>
              <template v-if="column.dataIndex === 'createAt'">
                {{ transformLocalDate(text) }}
              </template>
            </template>
          </a-table>
        </div>
      </div>

      <a-modal
        v-model:visible="visible"
        :closable="false"
        :footer="null"
        :bodyStyle="{ background: '#080718ff' }"
        style="top: 30%"
        width="1200px"
        :maskClosable="false"
      >
        <div style="color: #fff">
          <div class="w-full flex">
            <div class="flex-1"></div>
            <div class="cursor-pointer" @click="visible = false">
              <close-outlined style="font-size: 20px; color: #fff !important" />
            </div>
          </div>
          <div class="text-center w-full" style="font-size: 24px">
            {{ getLanguage("处理报警") }}
          </div>

          <a-form
            ref="formRef"
            name="advanced_search"
            class="ant-advanced-search-form"
            style="margin-top: 20px"
            :model="form"
          >
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-item
                  v-if="!isEdit"
                  name="operator"
                  :label=" getLanguage('操 作 人')"
                  required
                >
                  <a-input v-model:value="form.operator" readonly />
                </a-form-item>
                <a-form-item
                  v-if="!isEdit"
                  name="operateTime"
                  :label="getLanguage('操作时间')"
                  required
                >
                  <a-input v-model:value="form.operateTime" readonly />
                </a-form-item>
                <a-form-item name="remark" :label="getLanguage('处理备注')" required>
                  <a-textarea
                    :readonly="!isEdit"
                    v-model:value="form.remark"
                    placeholder=""
                    :rows="4"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>

          <div class="w-full flex justify-center" v-if="isEdit">
            <div
              @click="submitClose"
              style="
                background-color: #171325ff;
                padding: 5px 10px;
                width: 100px;
                font-size: 20px;
                text-align: center;
                cursor: pointer;
              "
            >
              {{ getLanguage("提交") }}
            </div>
          </div>
        </div>
      </a-modal>
    </div>
  </a-config-provider>
</template>

<script lang="ts" setup>
import request from "../../common/request";
import { useRouter } from "vue-router";
import { computed, onMounted, readonly } from "vue";
import { ref, reactive, watch } from "vue";
import type { UploadProps } from "ant-design-vue";
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";
const router = useRouter();
const loading = ref(false);
/**操作日志记录 */
import { operateLogs } from "@/common/logs";
import { getLanguage } from "@/common/translate";
import { transformDate2, transformBeiJingDate, transformLocalDate } from "@/common/tools";
operateLogs("Access hardware alarms");
/**操作日志记录 */
let language: any = ref("English");
const getLang = () => {
  language.value = localStorage.getItem("language") || "English";
};
getLang();

let dataList: any = ref([]);
const columns = [
  {
    title: getLanguage("监测类型"),
    dataIndex: "type",
    align: "center",
  },
  {
    title: getLanguage("故障模式"),
    dataIndex: "type",
    align: "center",
  },
  {
    title: getLanguage("报警内容"),
    dataIndex: "message",
    align: "center",
  },
  {
    title: getLanguage("报警时间"),
    dataIndex: "createAt",
    align: "center",
  },
  {
    title: getLanguage("报警状态"),
    dataIndex: "status",
    align: "center",
  },
];

let searchModel: any = ref({
  skip: 1,
  take: 20,
  total: 0,
  type: null,
});
const pagination = computed(() => ({
  total: searchModel.value.total,
  current: searchModel.value.skip,
  pageSize: searchModel.value.take,
}));

let typeList: any = [
  { label: "传感器", value: 7 },
  { label: "数采器", value: 6 },
];
let statusList: any = [
  { label: "未处理", value: 0 },
  { label: "已处理", value: 1 },
];
let selectedRowKeys: any = ref();
let visible: any = ref(false);
let isEdit: any = ref(false);
let form = ref({
  remark: "",
});

onMounted(() => {
  init();
});

const init = () => {
  getData();
};

const reset = () => {
  searchModel.value.type = null;
  searchModel.value.status = null;
  searchModel.value.date = null;
};

const search = () => {
  searchModel.value.skip = 1;
  getData();
};

const getData = async () => {
  let config: any = {
    params: {
      skip: searchModel.value.skip,
      take: searchModel.value.take,
      status: searchModel.value.status,
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  if (searchModel.value.type) {
    config.params.type = [searchModel.value.type];
  } else {
    config.params.type = [6, 7];
  }

  if (searchModel.value.date && searchModel.value.date.length === 2) {
    config.params.begin = transformBeiJingDate(transformDate2(
      new Date(searchModel.value.date[0]),
      1
    ));
    config.params.end = transformBeiJingDate(transformDate2(new Date(searchModel.value.date[1]), 2));
  }

  let result = await request.get("/api/sys-alarm/messages/list", config);
  console.log("result", result);
  dataList.value = result?.data?.list || [];
  searchModel.value.total = result?.data?.count || 0;
};

const getCheckboxProps = (record: any) => ({
  disabled: record.status === 1,
});

//复选框选择
const onSelectChange = (ev: any) => {
  selectedRowKeys.value = ev;
};

const handleTableChange = (pagination: any, filters: any, sorter: any) => {
  // 处理分页数据
  searchModel.value.skip = pagination.current;
  searchModel.value.take = pagination.pageSize;
  getData();
};

// 处理报警
const dealWith = () => {
  isEdit.value = true;
  console.log("selectedRowKeys.value", selectedRowKeys.value);
  if (!selectedRowKeys.value?.length)
    return message.warning("请选择报警后处理!");
  form.value.remark = "";
  visible.value = true;
};

// 提交处理报警
const submitClose = async () => {
  if (!form.value.remark) return message.warning("请填写处理备注!");
  let submit = {
    ids: selectedRowKeys.value,
    remark: form.value.remark,
  };
  let result = await request.post("/api/sys-alarm/messages/dealwith", submit);
  console.log("result", result);
  if (result?.data) {
    message.success("处理报警成功!");
    selectedRowKeys.value = [];
    visible.value = false;
    getData();
  }
};

// 查看已处理报警
const view = (ev: any) => {
  isEdit.value = false;
  visible.value = true;
  form.value.remark = ev.remark;
  form.value.operator = ev.operator;
  form.value.operateTime = ev.operateTime;
};

const getRowClassName = (record: any, index: any) => {
  // 根据索引设置不同的类名
  return index % 2 === 0 ? "even-row" : "odd-row";
};
</script>


<style lang="less" scoped>
.box {
  border: 1px solid #171325ff;
  background: #1b244633;
}

.txt-select {
  border-bottom: 4px solid #ffc000;
}

.btn {
  border: 1px solid #171325ff;
  background: #171325ff;
}

.fff {
  color: #fff;
}

/deep/ .ant-table {
  background: #080718ff;
  color: #fff;
}

/deep/ .ant-table-tbody > tr.ant-table-placeholder:hover > td {
  background: transparent;
}

/deep/ .ant-empty-normal {
  color: #fff;
}

/deep/ .ant-descriptions-item-content {
  color: #fff;
}

/deep/ .ant-table-tbody > tr > td {
  border-bottom: 0px solid #fff;
}

/deep/ .ant-picker-input > input {
  color: #000000ff;
}

/deep/ .ant-picker-clear span {
  background: #000 !important;
}

/deep/ .ant-drawer-close span svg {
  color: #000 !important;
}

/deep/ .ant-select-clear span {
  background-color: #000;
}

.event-btns {
  /deep/ .ant-btn {
    background-color: #686666ff;
    border: 1px solid #171325ff;
    color: #fff;
  }
}
</style>